var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fullHeightViewport backgroundLogin pa-0",style:(`
    background-image: url(${_vm.appPath});
    background-size: 66vw 100vh;
    background-position:  right  center ;`),attrs:{"fluid":""}},[_c('v-container',{staticClass:"container-custom pa-0"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mx-auto mx-sm-0",attrs:{"cols":"10","md":"4","sm":"6"}},[_c('router-view',{attrs:{"logoPath":_vm.logoPath}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }